import { CustomerAPI } from 'api'

export const fetchHubSpotEnrichmentByEmail = ({ email }) => {
  return CustomerAPI
    .get(`/hubspot/contact/enrichment?email=${encodeURIComponent(email)}`)
}